// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__Pk16p","list":"PatternAutocomplete_list__pULJr"};